
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/posts/[postId]",
      function () {
        return require("private-next-pages/community/posts/[postId].tsx");
      }
    ]);
  